import { action, observable, computed } from 'mobx'

interface IFilterMap {
    delivery_types?: ISelectData[]
    status_list?: ISelectData[]
    order_types?: ISelectData[]
    maximum_subtotal?: number | undefined
    minimum_subtotal?: number | undefined
    self_pickup_site_ids?: ISelectData[]
}

interface ISelectData {
    id: number
    name: string
}

class MallOrderFilterStore {
    @observable
    date: string[] = []

    @observable
    keyWord: string = ''

    @observable
    refresh: boolean = false

    @observable
    filterMap: {
        delivery_types: ISelectData[]
        status_list: ISelectData[]
        order_types: ISelectData[]
        maximum_subtotal: number | undefined
        minimum_subtotal: number | undefined
        self_pickup_site_ids: ISelectData[]
    } = {
        delivery_types: [],
        status_list: [],
        order_types: [],
        maximum_subtotal: void 0,
        minimum_subtotal: void 0,
        self_pickup_site_ids: [],
    }

    @action
    resetFilterMap() {
        this.setFilterMap({
            delivery_types: [],
            status_list: [],
            order_types: [],
            maximum_subtotal: void 0,
            minimum_subtotal: void 0,
            self_pickup_site_ids: [],
        })
    }

    @computed
    get filterTxt() {
        const filterArr = []

        let maximum_subtotal: number | undefined = void 0
        let minimum_subtotal: number | undefined = void 0

        // 数值处理
        if (this.filterMap.maximum_subtotal && this.filterMap.minimum_subtotal) {
            minimum_subtotal = Math.min(this.filterMap.maximum_subtotal, this.filterMap.minimum_subtotal)
            maximum_subtotal = Math.max(this.filterMap.maximum_subtotal, this.filterMap.minimum_subtotal)
        } else {
            minimum_subtotal = this.filterMap.minimum_subtotal || void 0
            maximum_subtotal = this.filterMap.maximum_subtotal || void 0
        }

        if (minimum_subtotal && maximum_subtotal) {
            filterArr.push(`¥${minimum_subtotal}~¥${maximum_subtotal}`)
        }
        if (!minimum_subtotal && maximum_subtotal) {
            filterArr.push(`¥0~¥${maximum_subtotal}`)
        }
        if (minimum_subtotal && !maximum_subtotal) {
            filterArr.push(`¥${minimum_subtotal}起`)
        }
        if (this.filterMap.delivery_types.length) {
            filterArr.push(this.filterMap.delivery_types.map(s => s.name).join('、'))
        }
        if (this.filterMap.status_list.length) {
            filterArr.push(this.filterMap.status_list.map(s => s.name).join('、'))
        }
        if (this.filterMap.order_types.length) {
            filterArr.push(this.filterMap.order_types.map(s => s.name).join('、'))
        }
        if (this.filterMap.self_pickup_site_ids.length) {
            filterArr.push(this.filterMap.self_pickup_site_ids.map(s => s.name).join('、'))
        }

        return filterArr.join('；')
    }

    @computed
    get filterQuery() {
        const isNoLen = (arr: any[]) => (arr.length ? arr.map(s => s.id) : void 0)

        let maximum_subtotal: number | undefined = void 0
        let minimum_subtotal: number | undefined = void 0

        // 数值处理
        if (this.filterMap.maximum_subtotal && this.filterMap.minimum_subtotal) {
            minimum_subtotal = Math.min(this.filterMap.maximum_subtotal, this.filterMap.minimum_subtotal)
            maximum_subtotal = Math.max(this.filterMap.maximum_subtotal, this.filterMap.minimum_subtotal)
        } else {
            minimum_subtotal = this.filterMap.minimum_subtotal || void 0
            maximum_subtotal = this.filterMap.maximum_subtotal || void 0
        }

        return {
            delivery_types: isNoLen(this.filterMap.delivery_types),
            status_list: isNoLen(this.filterMap.status_list),
            order_types: isNoLen(this.filterMap.order_types),
            maximum_subtotal,
            minimum_subtotal,
            self_pickup_site_ids: isNoLen(this.filterMap.self_pickup_site_ids),
        }
    }

    @action
    setFilterMap(map: IFilterMap) {
        this.filterMap = {
            ...this.filterMap,
            ...map,
        }
    }

    @action
    setkeyWord(keyWord: string) {
        this.keyWord = keyWord
    }

    @action
    setDate(date: string[]) {
        this.date = date
    }

    @action
    setRefresh() {
        this.refresh = !this.refresh
    }
}

export const mallOrderFilterStore = new MallOrderFilterStore()
